
export const Resource = {
    /** Avatars */
    // systemAvatar: './assets/images/logos/logo-sm.png',
    // defaultAvatar: './assets/images/avatar/default.jpg',
    // femaleDefaultAvatar: './assets/images/avatar/default_women.jpg',
    // maleDefaultAvatar: './assets/images/avatar/default_men.jpg',
    systemAvatar: './assets/images/admin_avatar.png',
    defaultAvatar: './assets/images/logon.jpg?v=2',
    femaleDefaultAvatar: './assets/images/logon.jpg?v=2',
    maleDefaultAvatar: './assets/images/logon.jpg?v=2',

    /** background */
    defaultBackground: './assets/images/user/default_bg.jpg',

    /** Membership */
    mVipBadge:         './assets/images/vip0.png',     // 普通用户 0
    mGVipBadge:        './assets/images/vip2.png',          // 收费会员 1
    mEtVipBadge:       './assets/images/vip3.png',         // 企业 Vip 2
    mCpVipBadge:       './assets/images/vip4.png',          // 情侣 Vip 3
    mRoyalVipBadge:    './assets/images/vip3.png',    // 高级会员
    mEditorBadge:      './assets/images/vip4.png',         // 小编 101
    mRoyalAdminBadge:  './assets/images/vip4.png',    // 站长 102
    mBigVBadge:        './assets/images/officalUp.png',    // 认证用户

    vipBadge:          './assets/images/vip0.png',       // 普通用户 0
    gVipBadge:         './assets/images/vip2.png',            // 收费会员 1
    etVipBadge:        './assets/images/vip3.png',           // 企业 Vip 2
    cpVipBadge:        './assets/images/vip4.png',            // 情侣 Vip 3
    royalVipBadge:     './assets/images/vip3.png',      // 高级会员 4
    editorBadge:       './assets/images/vip4.png',           // 小编 101
    royalAdminBadge:   './assets/images/vip4.png',      // 站长 102
    bigVBadge:         './assets/images/officalUp.png',      // 认证用户

    /** video resolution symbols */
    vrTS: './assets/images/ts.png',
    vr480P: './assets/images/480P.png',
    vr576P: './assets/images/576P.png',
    vr720P: './assets/images/720P.png',
    vr1080P: './assets/images/1080P.png',

    getGIDResource(gid)
    {
        if(gid ==0)
        {
            return '';
        }
        if(gid ==1)
        {
            return Resource.gVipBadge;
        }
        if(gid ==2)
        {
            return Resource.etVipBadge;
        }

        if(gid ==3)
        {
            return Resource.royalVipBadge;
        }
        if(gid ==4)
        {
            return Resource.cpVipBadge;
        }
        if(gid ==101)
        {
            return Resource.cpVipBadge;
        }
        if(gid ==102)
        {
            return Resource.cpVipBadge;
        }
        return '';
    }

};
